export default "__VITE_ASSET__388346e8__"